function onLayerUpdate(layerProvider, layerId, callback) {
  var excludeKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var options = arguments.length > 4 ? arguments[4] : undefined;
  return layerProvider.getLayerAsync(layerId, function (layer) {
    return layer.onUpdate(callback, excludeKeys, options);
  });
}

export { onLayerUpdate as default };
